import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap-5';
import { Button } from 'components/ui/button';

export default class BulkDeleteModal extends React.Component {
  static propTypes = {
    entityCount: PropTypes.number,
    entityName: PropTypes.string,
    shown: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
  };

  render() {
    const {
      entityCount,
      entityName,
      shown,
      onCancel,
      onDelete
    } = this.props;

    return (
      <Modal centered show={shown} onHide={onCancel}>
        <Modal.Header closeButton>
          <Modal.Title>Bulk Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-2">You are about to delete <strong>{entityCount} {entityName}</strong></div>
          <div className="mt-2">
            This action is permanent. If this contact is associated with a voucher,
            a copy will remain attached to the voucher but will not be editable.
            Are you sure you want to delete?
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button label="Cancel" variant="ghost" onClick={onCancel} />
          <Button variant="destructive" onClick={onDelete}>Delete {entityName}</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
